import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "toggleBtn", "openBtn", "headerBar"]

  fillSuggestion(event) {
    const suggestion = event.currentTarget.dataset.suggestion
    const input = document.getElementById('chat-input')
    if (input) {
      input.value = suggestion
      input.focus()
      const form = input.closest('form')
      if (form) form.requestSubmit()
    }
  }

  toggleSidebar() {
    if (!this.hasSidebarTarget) return
    const sidebar = this.sidebarTarget
    const isOpen = sidebar.style.width !== '0px'

    if (isOpen) {
      sidebar.style.width = '0px'
      sidebar.style.minWidth = '0px'
      sidebar.style.overflow = 'hidden'
      if (this.hasHeaderBarTarget) {
        this.headerBarTarget.classList.remove('hidden')
        this.headerBarTarget.classList.add('flex')
      }
    } else {
      sidebar.style.width = '260px'
      sidebar.style.minWidth = ''
      sidebar.style.overflow = ''
      if (this.hasHeaderBarTarget) {
        this.headerBarTarget.classList.add('hidden')
        this.headerBarTarget.classList.remove('flex')
      }
    }
  }

  // The spreadsheet viewer (sheet_viewer.js) docks on the right: the chat narrows to make room and
  // the sidebar folds away, coming back on close only if it was open before.
  sheetOpened() {
    this.element.querySelector('.laz-app')?.classList.add('xv-docked')
    if (this.hasSidebarTarget && this.sidebarTarget.style.width !== '0px') {
      this._reopenSidebar = true
      this.toggleSidebar()
    }
  }

  sheetClosed() {
    this.element.querySelector('.laz-app')?.classList.remove('xv-docked')
    // Unless the reader already opened it again while the sheet was up.
    if (this._reopenSidebar && this.sidebarTarget.style.width === '0px') this.toggleSidebar()
    this._reopenSidebar = false
    // The panel took the focused close button with it: the next keys belong in the composer.
    document.getElementById('chat-input')?.focus()
  }

  // Finance users write multi-line questions, so a plain Enter is a new line and only
  // ⌘+Enter / Ctrl+Enter sends. isComposing: never send mid-IME composition.
  handleKeydown(event) {
    if (event.key !== 'Enter' || !(event.metaKey || event.ctrlKey) || event.isComposing) return
    event.preventDefault()
    // Block submit if a question is already processing
    const loader = document.getElementById('loader')
    if (loader && loader.children.length > 0) return
    const form = event.target.closest('form')
    if (form) form.requestSubmit()
  }
}
